var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"flex flex-col bg-gray-50 rounded-md p-2"},[_c('div',[_vm._v(" Effective Date: "+_vm._s(_vm.effectiveDateDisplay)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }